import { connect } from "react-redux";
var Modal = require("components/utility/AltModal");
var LoadingButton = require("components/utility/LoadingButton");
var StudentsSelectedDisplay = require("components/org/roster/StudentsSelectedDisplay");
var DropDownOptions = require("components/utility/DropDownOptions");
var Glyphicon = require("components/utility/icons/Glyphicon");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var ButtonDropdown = require("components/utility/ButtonDropdown");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");

require("org/roster/student_subgroups.scss");

@connect(
	(state, props) => ({
		subgroups: RosterSelectors.subgroups({ state }),
		totalStudents: RosterSelectors.students({ state }).length
	}),
	(dispatch, props) => ({
		assignSubgroup: (studentIDs, subgroup) => {
			return dispatch(RosterActions.massUpdateStudentPrefs({
				studentIDs, update: { subgroup: subgroup },
				embeds: ["student.prefs"]
			}))
		}
	})
)
class StudentGroups extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { selectedAction: "addNewGroup", groupName: "" };
	}
	show() {
		this.refs.modal.show();
	}

	updateSubgroup() {
		this.setState({ loading: true })
		var students = this.props.students;
		if (this.state.selectedGroup) {
			var selectedGroup = this.state.selectedGroup;
			var key = selectedGroup.key;
			var name = selectedGroup.name;
			var color = selectedGroup.color;
			var icon = selectedGroup.icon;
		} else {
			var key = $wr.randomString(20); 
			var name = this.state.groupName;
			var color = this.state.selectedColorValue;
			var icon = this.state.selectedIconValue 
		}
		this.props.assignSubgroup(
			_.pluck(students, "id"),
			{ 	key: key,
				name:  name,
				color: color,
				icon: icon
			}
		).then(() => {
			setTimeout(function() {
				if (students.length > 1) {
					var text = "You added students to a group!";
				} else {
					var text = "You added a student to a group!";
				}
				window.wrNotifications.triggerDropDownNotification({
					title: "Groups Updated", text: text, 
					icon: "ok-circle" 
				});
				this.setState({ loading: false});
				if (this.props.onComplete) {
					this.props.onComplete();
				}
			}.bind(this), 100);
		})
	}

	resetSubgroup = () => {
		this.setState({ loading: true })
		var students = this.props.students;
		this.props.assignSubgroup(
			_.pluck(students, "id"),
			null
		).then(() => {
			setTimeout(function() {
				if (students.length > 1) {
					var text = "You removed students from a group!";
				} else {
					var text = "You removed a student from a group!";
				}
				window.wrNotifications.triggerDropDownNotification({
					title: "Groups Updated", text: text, 
					icon: "ok-circle" 
				});
				this.setState({ loading: false});
				if (this.props.onComplete) {
					this.props.onComplete();
				}
			}.bind(this), 100);
		})
	}

	renderStudentsSelected() {
		return (
			<div className="section">
				<p className="title">Students</p>
				<StudentsSelectedDisplay totalStudents={ this.props.totalStudents }
					studentsSelected={ this.props.students }
					hideTo />
			</div>
		)
	}

	renderActionOptions() {
		const students = this.props.students;
		var studentsWithGroups = 0;

		students.map(function(student) {
			if (!_.isEmpty(student.prefs.subgroup)) {
				studentsWithGroups ++;
			} 
		});

		if (students.length == studentsWithGroups) {
			var remomveOption = (
				<label className="normal">
					<input type="radio" checked={ this.state.selectedAction == REMOVE_FROM_GROUP } 
						onChange={ () => this.setState({ selectedAction: REMOVE_FROM_GROUP }) }
					/>Remove from group
				</label>
			)
		}
		return (
			<div className="section">
				<label className="normal">
					<input type="radio" checked={ this.state.selectedAction == ADD_NEW_GROUP } 
						onChange={ () => this.setState({ selectedAction: ADD_NEW_GROUP }) }
					/>Add to new group <br/>
				</label><br />

				<label className="normal">
					<input type="radio" checked={ this.state.selectedAction == ADD_TO_OLD_GROUP } 
						onChange={ () => this.setState({ selectedAction: ADD_TO_OLD_GROUP }) }
					/>Add to existing group <br/>
				</label><br />
				{ remomveOption }
			</div>
		)
	}

	isInvalid() {
		return !(this.state.selectedColorKey && this.state.selectedIconKey && this.state.groupName.trim());
	}

	selectColor = (color) => {
		this.setState({ selectedColorKey: color.key, selectedColorValue: color.props.value })
	}

	selectedColorText = () => {
		if (this.state.selectedColorKey) {
			return this.state.selectedColorKey;
		} else {
			return "Select Color";
		}
	}

	selectIcon = (icon) => {
		this.setState({ selectedIconKey: icon.key, selectedIconValue: icon.props.value })
	}

	selectedIconText = () => {
		if (this.state.selectedIconKey) {
			var colorValue = this.state.selectedColorValue;
			return (
				<span>
					<Glyphicon icon={ this.state.selectedIconValue }
						style={ colorValue ? { color: colorValue } : { color: "#555" } } /> 
					{ this.state.selectedIconKey }
				</span>
			)
		} else {
			return "Select Icon";
		}
	}

	selectGroup = (group) => {
		this.setState({ selectedGroup: group })
	}

	selectedGroupText = () => {
		if (this.state.selectedGroup) {
			var colorValue = this.state.selectedGroup.color;
			return (
				<span>
					<Glyphicon icon={ this.state.selectedGroup.icon }
						style={ colorValue ? { color: colorValue } : { color: "#555" } } /> 
					{ this.state.selectedGroup.name }
				</span>
			)
		} else {
			return "Select Group";
		}
	}

	renderGroupForm() {
		const students = this.props.students;

		var colorOptions = DropDownOptions.Select.GroupColors().map((color) => {
			var key = color.key;
			var value = color.props.value;
			return (
				<ButtonDropdownOption key={ key } onClick={ () => this.selectColor(color) }>
					<Glyphicon icon={ value } /> { key }
				</ButtonDropdownOption>
			);
		});
		var iconOptions = DropDownOptions.Select.GroupIcons().map((icon) => {
			var key = icon.key;
			var value = icon.props.value;
			var colorValue = this.state.selectedColorValue;
			return (
				<ButtonDropdownOption key={ key } onClick={ () => this.selectIcon(icon) }>
					<Glyphicon icon={ value } style={ colorValue ? { color: colorValue } : { color: "#555" } } /> { key }
				</ButtonDropdownOption>
			);
		});
		if (this.state.selectedAction == ADD_NEW_GROUP) {
			var buttonText = students.length > 1 ? "Add Students" : "Add Student";
			var button = (
				<LoadingButton className="buttonSuccess center-block" text={ buttonText } 
					disabled={ this.isInvalid() }
					loading={ this.state.loading } onClick={ this.updateSubgroup }/>
			)
			var formFields = (
				<div className="newGroupContainer">
					<p className="title">Group</p>
					<input className="form-control" type="text" placeholder="Group Name..."
						value={ this.state.groupName }
						onChange={ (e) => this.setState({ groupName: e.target.value }) } />
					<ButtonDropdown text={ this.selectedColorText() } className="" dropdownDisplay="link">
						{ colorOptions }
					</ButtonDropdown>
					<ButtonDropdown text={ this.selectedIconText() } className="" dropdownDisplay="link">
						{ iconOptions }
					</ButtonDropdown>
				</div>
			)
		} else if (this.state.selectedAction == ADD_TO_OLD_GROUP) {
			var buttonText = students.length > 1 ? "Add Students" : "Add Student";
			var button = (
				<LoadingButton className="buttonSuccess center-block" text={ buttonText } 
					loading={ this.state.loading } onClick={ this.updateSubgroup } />
			)
			var groupOptions = this.props.subgroups.map((group) => {
				var color = group.color;
				var key = group.key;
				var name = group.name;
				var icon = group.icon;
				return (
					<ButtonDropdownOption key={ key } onClick={ () => this.selectGroup(group) }>
						<Glyphicon icon={ icon } 
							style={{ color: color }} /> { name }
					</ButtonDropdownOption>
				);
			});
			var formFields = (
				<div>
					<p className="title">Group</p>
					<ButtonDropdown text={ this.selectedGroupText() } className="" dropdownDisplay="link">
						{ groupOptions }
					</ButtonDropdown>
				</div>
			)
		} else if (this.state.selectedAction == REMOVE_FROM_GROUP) {
			var buttonText = students.length > 1 ? "Remove Students" : "Remove Student";
			var button = (
				<LoadingButton className="buttonSuccess center-block" text={ buttonText } 
					loading={ this.state.loading } onClick={ this.resetSubgroup } />
			)
			// if (this.props.students[0].prefs.subgroup) {
			// 	var group = this.props.students[0].prefs.subgroup;
			// 	var groupInformation = (
			// 		<div className="groupInformation">
			// 			<p>
			// 				<Glyphicon icon={ group.icon } 
			// 				style={{ color: group.color }} />{ group.name }
			// 			</p>
			// 		</div>
			// 	)
			// }
		}
		return (
			<div>
				{ formFields }
				{ button }
			</div>
		)
	}

	render() {
		var groups = this.props.subgroups;
		if (groups.length > 0) {
			var actions = this.renderActionOptions();
		}
		const modalBody = (
			<div className="studentSubgroups">
				{ this.renderStudentsSelected() }
				{ actions }
				{ this.renderGroupForm() }
			</div>
		)
		return (
			<div className="modal-body">
				{ modalBody }
			</div>
		);
	}
};

const ADD_NEW_GROUP = "addNewGroup";
const ADD_TO_OLD_GROUP = "addToGroup";
const REMOVE_FROM_GROUP = "removeFromGroup";

StudentGroups.WrappedComponent.propTypes = StrictPropTypes({
	// From above
	students: PropTypes.array,
	onComplete: PropTypes.func,
	
	// Data from @connect
	subgroups: PropTypes.array,
	totalStudents: PropTypes.number,
	
	// Handlers from @connect
	assignSubgroup: PropTypes.func,
});

module.exports = StudentGroups;



// WEBPACK FOOTER //
// ./modules/components/org/roster/StudentSubgroups.js